import React from "react";
import "./HomePage.css";

const HomePage = () => {
  return (
    <div className="homepage">
      <header className="homepage-header">
        <h1>Professional Immigration Services</h1>
        <p>Your trusted partner in U.S. immigration and document preparation.</p>
      </header>

      <section className="homepage-section">
        <h2>Who We Are</h2>
        <p>
          We are a dedicated team of immigration professionals committed to providing accurate, affordable, and timely support
          for your immigration needs. Our goal is to make the process easier and less stressful for individuals and families
          navigating the U.S. immigration system.
        </p>
      </section>

      <section className="homepage-section">
        <h2>Our Services</h2>
        <ul>
          <li>• Family Immigration Petitions (Spouse, Parent, Child)</li>
          <li>• Tourist & Non-Immigrant Visas (B1/B2)</li>
          <li>• Adjustment of Status (Green Card)</li>
          <li>• Green Card Renewal (Form I-90)</li>
          <li>• Citizenship / Naturalization (Form N-400)</li>
          <li>• U.S. Passport Application Assistance</li>
          <li>• DNA Testing Coordination (AABB Accredited Labs)</li>
        </ul>
        <p className="homepage-note">
          *Government filing fees are not included in our service fees.
        </p>
      </section>

      <section className="homepage-section">
        <h2>Why Clients Choose Us</h2>
        <p>
          ✔ Experienced professionals who care about your case  
          <br />
          ✔ Transparent pricing – no hidden fees  
          <br />
          ✔ Multilingual support  
          <br />
          ✔ Fast turnaround and support throughout your journey  
        </p>
      </section>

      <section className="homepage-contact">
        <h2>Let’s Get Started</h2>
        <p>
          Contact us today to schedule a consultation. We are here to answer your questions and help you move forward with
          confidence.
        </p>
        <div className="contact-buttons">
          <a
            href="https://wa.me/12067855269"
            className="contact-btn whatsapp"
            target="_blank"
            rel="noopener noreferrer"
          >
            📱 Message Us on WhatsApp
          </a>
          <a href="tel:+12067855269" className="contact-btn call">
            📞 Call Us
          </a>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
